import React from 'react';
import { StaticSplashContent } from '.';
import { STATIC_SPLASH_INFO_PANEL_1, STATIC_SPLASH_INFO_PANEL_2 } from 'src/client/constants/joinCampaigns';

export const ma: StaticSplashContent = {
  awards: ['xbiz2024', 'xbiz2019', 'xbiz2018', 'xbiz2017', 'xbiz2015', 'xbiz2011'],
  brandColor: '#f0ac18',
  brandHoverColor: '#d49715',
  classics: {
    description: (
      <>
        Over 25 years of timeless, uninhibited, novice beauty
        <br /> — Est. 1999
      </>
    ),
    title: 'METART CLASSICS',
  },

  galleries: {
    description:
      'Over 2.5 million images featuring breathtaking models in exotic locations, shot by internationally renowned photographers.',
    path: '/galleries',
    title: 'ELITE EROTIC PHOTOGRAPHY',
  },
  infoPanels: {
    one: {
      buttonText: 'BECOME A MEMBER NOW',
      campaign: STATIC_SPLASH_INFO_PANEL_1,
      description: (
        <>
          Get Unlimited, Uncensored Access to <br />
          our Award-Winning Site
        </>
      ),
      highlightText:
        "Established in 1999 Metart is the gold standard for artistic nudes and the world's largest erotic art community.",
    },
    two: {
      buttonText: 'JOIN OUR MODELS TODAY',
      campaign: STATIC_SPLASH_INFO_PANEL_2,
      description: (
        <>
          Get Unlimited, Uncensored Access to <br />
          Our Award-Winning Site
        </>
      ),
      highlightText: 'Erotic art is distinguished by its ability to engage your senses on multiple levels.',
    },
  },

  intro: {
    buttonText: 'START YOUR EROTIC JOURNEY NOW',
    buttonTextNonNude: 'UNLOCK EXPLICIT NUDITY NOW',
    largeTagline: (
      <>
        Metart's outstanding lineup of erotic nude <br />
        art Film and Photography is without equal
      </>
    ),
    smallTagline: (
      <>
        Enjoy flawless natural beauty featuring <br />
        multiple daily updates
      </>
    ),
  },
  models: {
    description:
      'Over 4300 nude models including Mila Azul, Katya Clover, Dakota Pink and fresh faced newcomers making their international debut.',
    path: '/models',
    title: (
      <>
        THE WORLD'S MOST <br />
        ALLURING GIRLS
      </>
    ),
  },
  movies: {
    description: 'Over 2200 provocative movies. Every detail a sensual feast.',
    path: '/erotic-films',
    title: 'EXCEPTIONAL FILMMAKING',
  },
  outro: {
    buttonText: 'JOIN METART TODAY',
    largeTagline: (
      <>
        Step into a world where every <br />
        frame is a masterpiece
      </>
    ),
    smallTagline: (
      <>
        Unlock the world's most exclusive <br />
        collection of erotic art.
      </>
    ),
    smallTaglineNonNude: (
      <>
        Unlock the world's most exclusive <br />
        collection of explicit, nude, erotic art.
      </>
    ),
  },
  seoText: (
    <>
      It's not just about what you see but how you feel and experience the engaging content. At the forefront of this
      transformative experience is Metart, a platform celebrated for its exceptional approach to erotic art. Metart is
      not just a collection of erotic female photos; it is a unique blend of artistic and erotic content that transforms
      the viewer's experience from mere fantasy to a deeply personal and immersive reality.
    </>
  ),
};
